import { Search as SearchIcon } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import { customPalette } from '../../../themes/customTheme';

export const SearchField = ({
  value,
  onChange,
  label = 'Buscar',
  placeholder = 'Buscar...',
}) => {
  const handleChange = event => {
    onChange(event.target.value);
  };

  return (
    <TextField
      value={value || ''}
      onChange={handleChange}
      label={label}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      sx={{
        width: 250,
        '& .MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: customPalette.primary.main,
          },
          '&.Mui-focused fieldset': {
            borderColor: customPalette.primary.main,
          },
        },
        '& .MuiInputLabel-root': {
          '&.Mui-focused': {
            color: customPalette.primary.main,
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
